import { EmptyView, emptyViewVariants } from '@components'

import { Module, ModuleLayout, Space } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { useIsSalesReportDataEmpty } from '../../hooks/useIsSalesReportDataEmpty'

export const SalesReportEmpty = (): ReactElement | null => {
  const { t } = useTranslation()

  const isSalesReportDataEmpty = useIsSalesReportDataEmpty()
  const navigate = useNavigate()

  const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)

  const { url: reportsUrl } = useOrganizationViewUrl(reactRoute.organization.salesReport.getMainRoute())
  const { url: invoiceNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
  )

  const handleEmptyViewClick = useCallback(() => {
    if (invoiceNewUrl) {
      navigate(invoiceNewUrl)
    }
  }, [invoiceNewUrl, navigate])

  const { animation, description, title, buttonText } = emptyViewVariants.salesReport

  if (!reportsUrl) {
    return null
  }

  if (!isSalesReportDataEmpty) {
    return <Navigate to={reportsUrl} replace />
  }

  return (
    <ModuleLayout title={t('sales_report')}>
      <Module>
        <Space size="s24" />
        <EmptyView
          animationName={animation}
          onClick={handleEmptyViewClick}
          showCTA
          tButton={buttonText}
          tDescription={description}
          tTitle={title}
        />
        <Space size="s24" />
      </Module>
    </ModuleLayout>
  )
}
